module.exports = "/assets/68fd82f6d8c05667eb57568b29a456a1.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/OT.png
// module id = 1692
// module chunks = 0